module.exports = __webpack_public_path__ + "assets/img/btn1.b5633791.png";